import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { BaseStyleEnums, ReactTable } from '@nhl/nhl-breakaway-ui';

import { useSizeWithThrottle } from '~/core/hooks/useSizeWithThrottle';
import { defaultLocationData, useLocationQuery } from '~/redux/ducks/location';

import getPlayoffSeriesColumns from '../../components/PlayoffSeriesTable/columns';
import { PlayoffSeriesGame, PlayoffSeriesTeam } from '../../types';

import { ReactTableContainer } from './styles';

type PlayoffSeriesTableProps = {
    data: Array<PlayoffSeriesGame>;
    bottomSeedTeam: PlayoffSeriesTeam;
    topSeedTeam: PlayoffSeriesTeam;
    neededToWin: number;
};

const PlayoffSeriesTable: FC<PlayoffSeriesTableProps> = ({ data, bottomSeedTeam, topSeedTeam, neededToWin }) => {
    const { data: countryCode = defaultLocationData } = useLocationQuery({});

    const intl = useIntl();
    const screenSize = useSizeWithThrottle();
    const isMediumScreenOrSmaller = screenSize.width < BaseStyleEnums.ScreenWidthBreakpoints.large;
    return (
        <ReactTableContainer>
            <ReactTable
                columns={getPlayoffSeriesColumns(
                    intl,
                    bottomSeedTeam,
                    topSeedTeam,
                    countryCode,
                    neededToWin,
                    isMediumScreenOrSmaller
                )}
                data={data}
            />
        </ReactTableContainer>
    );
};

export default PlayoffSeriesTable;
